import styled from "styled-components";
import {
  spacing,
  color,
  palette,
  elevation,
  borderRadius,
} from "@conserveit/blocks";

/**
 * Outermost `<form />` element
 */
export const FormContainer = styled.form`
  border-radius: 3px;
  box-shadow: ${elevation.content};
`;

/**
 * Container for the form title
 *
 * TODO: Port to FrameView and use typography components instead
 */
export const Header = styled.div`
  padding: ${spacing.default};
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  border-bottom: 1px solid ${palette.neutral4};
  background-color: ${color.pureWhite};
`;

/**
 * Content box around form elements
 */
export const Content = styled.div`
  padding: ${spacing.extraLoose} ${spacing.ultraLoose};
  background-color: ${color.pureWhite};
`;

// TODO: Remove this
export const ErrorMessage = styled.div`
  padding: ${spacing.default};
  margin-bottom: ${spacing.loose};

  font-weight: 700;

  background-color: ${palette.red1};
  border: 1px solid ${palette.red5};
  color: ${palette.red7};
  border-radius: ${borderRadius.default};
`;
export const SuccessMessage = styled(ErrorMessage)`
  background-color: ${palette.green1};
  border: 1px solid ${palette.green5};
  color: ${palette.green7};
`;
/**
 * Outermost element for the footer
 * TODO: Port to FrameView
 */
export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${spacing.default};
  border-top: 1px solid ${color.theme.divider.solid};
  background-color: ${color.pureWhite};
`;

/**
 * Content wrapper inside outermost footer element
 * TODO: Port to FrameView
 */
export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
`;

export const HelpLink = styled.a`
  font-size: 12px;
  font-weight: 700;
  color: ${palette.neutral7};
  text-decoration: underline;

  &:hover,
  &:focus,
  &:active {
    color: ${color.theme.typography.ink};
  }
`;
